<template>
  <div v-if="!hidden" class="top">
    <div class="steplabel">
      مرحله <b>{{ faIndex }}</b> از {{ faTotal }} — {{ label }}
    </div>
    <div class="bars" role="progressbar" :aria-valuenow="index" aria-valuemin="1" :aria-valuemax="total">
      <i v-for="n in total" :key="n" :class="{ on: n <= index }"></i>
    </div>
  </div>
</template>

<script>
import { FLOW_ORDER, STEP_LABELS } from "@/constants";
import { toFa } from "@/utils/digits";

/**
 * "مرحله ۲ از ۴" plus the segmented progress bar.
 *
 * Position comes from FLOW_ORDER rather than a hardcoded number, so reordering the flow
 * cannot leave a screen claiming to be step 3 when it is now step 2.
 *
 * Hidden entirely in edit mode: re-entering one item from the review screen is not
 * "step 2 of 4" — showing progress there would misdescribe what the user is doing.
 */
export default {
  name: "StepHeader",

  props: {
    /** Route name of the current step. */
    step: { type: String, required: true },
    hidden: { type: Boolean, default: false },
  },

  computed: {
    total() {
      return FLOW_ORDER.length;
    },
    index() {
      return FLOW_ORDER.indexOf(this.step) + 1;
    },
    label() {
      return STEP_LABELS[this.step] || "";
    },
    faIndex() {
      return toFa(this.index);
    },
    faTotal() {
      return toFa(this.total);
    },
  },
};
</script>

<style scoped>
.top {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 8px;
}

.steplabel {
  font-size: 13px;
  font-weight: 500;
  color: var(--muted-foreground);
}

.steplabel b {
  color: var(--foreground);
  font-weight: 700;
}

.bars {
  display: flex;
  gap: 6px;
}

.bars i {
  height: 6px;
  flex: 1;
  border-radius: 999px;
  background: var(--muted);
  transition: background 0.3s;
}

.bars i.on {
  background: var(--primary);
}
</style>
